import { render } from "./About.vue?vue&type=template&id=32f2cf9e&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=32f2cf9e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/motokandemir-web/motokandemir-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f2cf9e"]])

export default __exports__